<template>
  <div class="vote">

    <div class="question">
      <h2 class="normal">投票管理</h2>
      <div class="normal">主题：<textarea rows="5" cols="50" v-model="tag_name"></textarea></div>
      <div class="normal">类型：
        <select name="" id="" v-model="vote_type">
          <option value="调研投票">调研</option>
          <option value="活动投票">活动</option>
        </select>
      </div>
      <div class="center">
        <button @click="updateTheme" class="up">新增主题</button>
      </div>
      <div class="normal">题目：<textarea rows="5" cols="50" v-model="title"></textarea></div>
      <div class="normal">类型：
        <select name="" id="" v-model="type">
          <option value="单选">单选</option>
          <option value="多选">多选</option>
        </select>
      </div>
      <div class="normal1">
        <button @click="addOption">增加选项</button>
      </div>
      <div class="options" v-for="(option,index) in options" :key="index">
        <div class="normal">选项：
          <textarea rows="5" cols="50" v-model="options[index].words"></textarea>
        </div>
        <div class="normal">
          <input type="file" @change="chooseImage" :id="'optionImage'+index">
          <button @click="delOption(index)">删除选项</button>
          <input type="text" v-model="options[index].baseNum">
        </div>
        <img :src="options[index].image" alt="">
      </div>
      <div class="center">
        <div v-if="currentTheme.id">主题：{{currentTheme.tag_name}}</div>
        <button @click="updateQuestion" class="up">上传问题</button>
      </div>
    </div>

    <div class="box">
      <div class="data">
        <div v-for="(item,index) in questionList" :key="item.id" :class="{'data-item-cur':questionListCurrent.indexOf(index) > -1,'data-item':true}"
          @click="onQuestionItemClick(index)">{{index + 1}}.{{item.interact_content.title}}</div>
      </div>
    </div>

    <div class="box">
      <div class="input">
        <input type="text" @input="onTitleInput" v-model="searchText">
      </div>
      <div class="data">
        <div v-for="(item,index) in searchList" :key="item.id" :class="{'data-item-cur':searchListCurrent.indexOf(index) > -1,'data-item':true}"
          @click="onSearchItemClick(index)">{{item.type.slice(0,2)}}.{{item.tag_name}}</div>
      </div>
      <div class="control">
        <div class="control-item" @click="toSeeQuestion">看问题</div>
        <div class="control-item" @click="toAddQuestion">添问题</div>
        <div class="control-item" @click="toBeVoting">去投票</div>
      </div>
    </div>

    <div class="box">
      <div class="data">
        <div v-for="(item,index) in votingList" :key="item.id" :class="{'data-item-cur':votingListCurrent.indexOf(index) > -1,'data-item':true}"
          @click="onVotingItemClick(index)">{{index + 1}}.{{item.type.slice(0,2)}}.{{item.tag_name}}</div>
      </div>
      <div class="control">
        <div class="control-item" @click="updateVotingList" style="background-color:red">更新</div>
        <div class="control-item" @click="del">删除</div>
        <div class="control-item" @click="toBeVoted">结束投票</div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        tag_name: '',
        currentTheme: {},
        questionList: [],
        questionListCurrent: [],
        vote_type: '调研投票',

        title: '',
        type: '单选',
        options: [],

        searchText: '',
        allVoteList: [],
        searchList: [],
        searchListCurrent: [],
        votingList: [],
        // tempList:[],
        votingListCurrent: [],
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      init() {
        let that = this
        that.$axios.get(that.$url_prefix + 'queryThemeList', {
          params: {
            type: '投票',
            status: 'WAIT'
          }
        }).then(function (res) {
          console.log('查询待投票返回', res)
          let list = res.data.data
          that.allVoteList = JSON.parse(JSON.stringify(list))
          that.searchList = JSON.parse(JSON.stringify(list))
        }).catch(function (res) {
          console.log('查询待投票失败', res)
        })
        that.$axios.get(that.$url_prefix + 'queryThemeList', {
          params: {
            type: '投票',
            status: 'ING'
          }
        }).then(function (res) {
          console.log('查询投票中返回', res)
          let list = res.data.data
          that.votingList = JSON.parse(JSON.stringify(list))
        }).catch(function (res) {
          console.log('查询投票中失败', res)
        })
      },
      addOption() {
        this.options.push({
          words: '',
          image: '',
          baseNum: ''
        })
      },
      delOption(index) {
        this.options.splice(index, 1)
      },

      
      //选择图片
      chooseImage(event) {
        let that = this
        let origin = event.target.id.replace('optionImage', '')
        let option = {
          file: event.target.files[0],
          head_name: 'vote',
        }
        that.$uploadImage(option).then(function (res) {
          console.log('upload back', res)
          if (!res) {
            console.log('upload fail')
            return false;
          }

          that.options[origin].image = res
          that.$previewRefresh()

        }).catch(function (res) {
          console.log('upload fail', res)
        })
      },


      updateTheme() {
        let that = this
        if (that.tag_name.length === 0) {
          return;
        }
        let obj = {
          tag_name: that.tag_name,
          tag_status: 'WAIT',
          type: that.vote_type
        }
        let param = {
          'db': 'WpTagModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('新增主题返回', res)
          that.tag_name = ''
          that.init()
        }).catch(function (res) {
          console.log('新增主题失败', res)
        })
      },
      updateQuestion() {
        let that = this
        if (that.options.length === 0) {
          return;
        }
        if (!that.currentTheme.id) {
          alert('请选择一个主题')
          return;
        }
        let baseNum = 0;
        for (let i = 0; i < that.options.length; i++) {
          that.options[i].id = i
          if(that.options[i].baseNum !== ''){
            baseNum += parseInt(that.options[i].baseNum)
          }
        }
        let content = {
          title: that.title,
          type: that.type,
          baseNum: baseNum,
          options: that.options
        }
        let obj = {
          interact_type: '问题',
          interact_content: JSON.stringify(content),
          tag_id: that.currentTheme.id
        }
        let param = {
          'db': 'WpInteractModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('新增问题返回', res)
          that.options = []
          that.title = ''
          // that.init()
        }).catch(function (res) {
          console.log('新增问题失败', res)
        })
      },


      onTitleInput() {
        let that = this
        that.searchListCurrent = []
        let list = JSON.parse(JSON.stringify(that.allVoteList))
        let matchList = []
        for (let i in list) {
          let name = list[i].interact_content.title
          let flag = 0
          for (let j = 0; j < that.searchText.length; j++) {
            if (name.indexOf(that.searchText[j]) > -1) {
              flag++
            }
          }
          if (flag > 0) {
            list[i].flag = flag
            matchList.push(list[i])
          }
        }
        if (matchList.length > 0) {
          matchList.sort((a, b) => {
            return b.flag - a.flag
          })
          that.searchList = matchList
        } else {
          that.searchList = list
        }
      },

      onSearchItemClick(index) {
        let that = this
        let temp = that.searchListCurrent.indexOf(index)
        if (temp > -1) {
          that.searchListCurrent.splice(temp, 1)
        } else {
          that.searchListCurrent.push(index)
        }
      },

      toBeVoting() {
        let that = this
        if (that.searchListCurrent.length === 0) {
          return;
        }
        outer:
          for (let i = 0; i < that.searchListCurrent.length; i++) {
            let obj = JSON.parse(JSON.stringify(that.searchList[that.searchListCurrent[i]]))
            inner:
              for (let i = 0; i < that.votingList.length; i++) {
                if (that.votingList[i].id === obj.id) {
                  continue outer;
                }
              }
            that.votingList.push(obj)
          }
        that.searchListCurrent = []
      },
      toSeeQuestion() {
        let that = this
        if (that.searchListCurrent.length === 1) {
          let tag_id = that.searchList[that.searchListCurrent[0]].id
          that.searchListCurrent = []
          that.$axios.get(that.$url_prefix + 'queryQuestionList', {
            params: {
              tag_id: tag_id
            }
          }).then(function (res) {
            console.log('查询问题返回', res)
            let list = res.data.data.questionList
            that.questionList = JSON.parse(JSON.stringify(list))
          }).catch(function (res) {
            console.log('查询问题失败', res)
          })
        }

      },
      toAddQuestion() {
        let that = this
        if (that.searchListCurrent.length === 1) {
          that.currentTheme = that.searchList[that.searchListCurrent[0]]
          that.searchListCurrent = []
        }
      },

      onVotingItemClick(index) {
        let that = this
        let temp = that.votingListCurrent.indexOf(index)
        if (temp > -1) {
          that.votingListCurrent.splice(temp, 1)
        } else {
          that.votingListCurrent.push(index)
        }
      },
      onQuestionItemClick(index) {
        let that = this
        let temp = that.questionListCurrent.indexOf(index)
        if (temp > -1) {
          that.questionListCurrent.splice(temp, 1)
        } else {
          that.questionListCurrent.push(index)
        }
      },

      del() {
        let that = this
        if (that.votingListCurrent.length === 0) {
          return;
        }
        let restList = []
        for (let i = 0; i < that.votingList.length; i++) {
          if (that.votingListCurrent.indexOf(i) === -1) {
            restList.push(that.votingList[i])
          }
        }

        that.votingList = restList
        that.votingListCurrent = []

      },

      toBeVoted() {
        let that = this
        if (that.votingListCurrent.length === 0) {
          return;
        }
        let votedList = []
        let restList = []
        for (let i = 0; i < that.votingList.length; i++) {
          if (that.votingListCurrent.indexOf(i) > -1) {
            votedList.push(that.votingList[i])
          } else {
            restList.push(that.votingList[i])
          }
        }
        that.toBeVotedCircle(votedList, restList)

      },

      toBeVotedCircle(list, restList) {
        let that = this
        if (list.length === 0) {
          that.votingList = restList
          that.votingListCurrent = []
          return false;
        }
        let temp = list.splice(0, 1)[0]
        let obj = {
          id: temp.id,
          tag_status: 'OVER'
        }
        let param = {
          'db': 'WpTagModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('跟新问题状态返回', res)
          that.toBeVotedCircle(list, restList)
        }).catch(function (res) {
          console.log('跟新问题状态失败', res)
        })
      },

      updateVotingList() {
        let that = this
        if (that.votingList.length > 0) {
          let list = JSON.parse(JSON.stringify(that.votingList))
          that.updateVotingListCircle(list)
        }
      },
      updateVotingListCircle(list) {
        let that = this
        if (list.length === 0) {
          that.votingListCurrent = []
          that.init()
          alert('更新成功')
          return false;
        }
        let temp = list.splice(0, 1)[0]
        let obj = {
          id: temp.id,
          tag_status: 'ING'
        }
        let param = {
          'db': 'WpTagModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('跟新问题状态返回', res)
          that.updateVotingListCircle(list)
        }).catch(function (res) {
          console.log('跟新问题状态失败', res)
        })
      },
    }
  }

</script>

<style scoped>
  .vote {
    display: flex;
    justify-content: space-around;
    margin-top: 60px;
  }

  .normal {
    margin: 10px 0;
  }

  .normal1 {
    margin: 20px 0;
  }

  textarea {
    vertical-align: top;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

  .up {
    margin-top: 20px;
    width: 150px;
    height: 50px;
    border-radius: 10px
  }

  .box {
    width: 300px;
    position: relative;
    user-select: none;
  }

  .input {
    position: absolute;
    left: 0;
    top: -25px;
  }

  .data {
    height: 500px;
    overflow-y: auto;
    border: 1px solid #000;
  }

  .data-item {
    background-color: pink;
    text-align: center;
    line-height: 30px;
    border-bottom: 1px solid #ccc;
  }

  .data-item-cur {
    background-color: yellow !important;
  }

  .control {
    margin-top: 5px;
    line-height: 30px;
    text-align: center;
    display: flex;
  }

  .control-item {
    border: 1px solid #000;
    background-color: #ef03ef;
    flex: 1;
  }

  .center {
    text-align: center;
    margin-bottom: 50px;
  }

  h2 {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/page/vote.vue